export enum PublicApiEndpointURLs {
  AUTHENTICATION_PATH_URL = 'auth/login',
  CLIENT_SESSIONS = '/client-tracking-context-api/client-sessions',
  CONFIRM_PLAN_CHANGE_BY_PLAN_ID = '/broadband/v1/plans/:planId/amendment',
  CPE_ORDERS = '/broadband/v1/cpe/orders',
  CREATE_DRAFT_PLAN = '/broadband/v1/plans',
  EVIDENCE_SESSION_BY_ID = '/broadband/v1/in-life/evidence-sessions/:evidenceSessionId',
  EVIDENCE_SESSION_CONFIRMATION = '/broadband/v1/in-life/evidence-sessions/:evidenceSessionId/confirmation',
  EVIDENCE_SESSION_EVIDENCE = '/broadband/v1/in-life/evidence-sessions/:evidenceSessionId/evidence',
  EVIDENCE_SESSION_EVIDENCE_BY_ID = '/broadband/v1/in-life/evidence-sessions/:evidenceSessionId/evidence/:evidenceId',
  GET_ACTIVE_APPOINTMENTS = '/broadband/v1/orders/:orderId/active-appointments',
  GENERATE_CONTRACT = '/broadband/v1/plans/:planId/pre-contracts',
  GET_CONTRACT = '/broadband/api/contracts/download-contract',
  GET_CONTRACT_DOC = '/broadband/v1/plans/:planId/contracts/:contractDocId',
  GET_MEMBER_CARD_DETAILS = '/payment-api/v3/members/me/payment-methods/card',
  GET_ORCHESTRATED_PAYMENTS = '/payment-initiator-api/v1/orchestrated-payments',
  GET_PAYMENTS_BY_CALLER_REFERENCE_ID = '/payment-api/v4/payments',
  GET_PLAN_AMENDMENT_PRODUCTS = '/broadband/v1/plans/:planId/amendment-products',
  ME = '/member-api/v1/members/me',
  MEMBER_ORDER_DETAILS = '/broadband/v1/orders/:orderId',
  MEMBER_PROFILE_OVERVIEW = '/broadband/v1/members/:memberId/profile',
  ORDER_SCHEDULES = '/order-scheduler-api/order-schedules/:scheduleId',
  PLAN_AMENDMENT_DETAILS_BY_PLAN_ID = '/broadband/v1/plans/:planId/amendment-details',
  PLAN_BUYOUT_CLAIM_BY_PLAN_ID = '/broadband/v1/in-life/plans/:planId/buyout-claim',
  PLAN_BUYOUT_DETAILS_BY_PLAN_ID = '/broadband/v1/in-life/plans/:planId/buyout-details',
  PLAN_BY_ID = '/broadband/v1/plans/:planId',
  PLAN_CHANGE_PREVIEW_BY_PLAN_ID = '/broadband/v1/plans/:planId/amendment-preview',
  PRODUCTS_BY_UPRN = '/broadband/v2/postcode-checker/products',
}
